import { Box, Button, Typography, styled, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IconArrowBackUp, IconCloudQuestion } from '@tabler/icons-react';
import config from 'globalConfig';
import { useEffect } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { animated, useSpring } from '@react-spring/web';

const SlidingBox = styled(animated(Box))(({ theme }) => ({}));

function NotFound() {
    const theme = useTheme();
    const [ctx, setCtx] = useOutletContext();

    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const matchUpSm = useMediaQuery(theme.breakpoints.up('sm'));
    const fadeSlideProps = useSpring({
        delay: Math.floor(Math.random() * (500 - 250 + 1) + 250),
        to: { opacity: 1, translateY: '0', filter: 'saturate(1), blur(1rem)' },
        from: { opacity: 0, translateY: '1rem', filter: 'saturate(0), blur(0)' },
        // delay: 100,
        config: {
            // mass: 1,
            // tension: 5000,
            // friction: 200,
            // precision: 0.0001,
            // velocity: 0,
            duration: 250
        }
    });
    useEffect(() => {
        setCtx((oldValues) => ({
            ...oldValues,
            route: [
                {
                    title: 'Not found',
                    // subtitle: recordId === 'new' ? '' : `${record?.title}`,
                    location: '/',
                    active: true
                }
            ]
        }));
    }, [setCtx]);
    return (
        <Box
            sx={{
                width: '100%',
                background: theme.palette.grey[50],
                height: 'calc(100vh - 3.5rem)',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    maxWidth: matchUpMd ? '70%' : '90vw'
                }}
            >
                <SlidingBox
                    style={fadeSlideProps}
                    sx={{
                        display: 'flex',
                        flexDirection: matchUpMd ? 'row' : 'column',
                        alignItems: matchUpMd ? 'flex-start' : 'center',
                        justifyContent: 'center',
                        width: '100%',
                        background: theme.palette.primary.light,
                        borderRadius: config.borderRadiusMd,
                        p: '1rem 1rem 1.5rem 0.5rem',
                        maxWidth: 550
                    }}
                >
                    {/* <IconCloudQuestion size={64} color={theme.palette.primary.dark} stroke={2} /> */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',

                            ml: '1rem'
                        }}
                    >
                        <Typography variant="title">Page not found</Typography>
                        <Typography variant="subtitle">
                            The page you are looking for might have been removed, had its name changed or is temporarily unavailable.
                        </Typography>
                    </Box>
                </SlidingBox>
                <SlidingBox
                    style={fadeSlideProps}
                    sx={
                        {
                            // display: 'flex',
                            // flexDirection: matchUpMd ? 'row' : 'column',
                            // alignItems: matchUpMd ? 'flex-start' : 'center',
                            // justifyContent: 'center',
                            // width: '100%',
                            // background: theme.palette.background.paper,
                            // borderRadius: config.borderRadiusMd,
                            // p: 2
                        }
                    }
                >
                    <Button
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        component={Link}
                        aria-label="button"
                        endIcon={<IconArrowBackUp size={24} stroke={2} />}
                        to="/"
                        sx={{
                            borderRadius: config.borderRadiusMd,
                            fontWeight: 500,
                            height: '2.5rem',
                            fontSize: '1rem',
                            mt: '1rem',
                            background: theme.palette.primary.light,
                            color: theme.palette.grey[200],
                            '&:hover': {
                                background: theme.palette.grey[100],
                                color: theme.palette.background.paper
                            }
                        }}
                        variant="contained"
                        color="primary"
                    >
                        Back to home
                    </Button>
                </SlidingBox>
            </Box>
        </Box>

        // {/* </animated.div> */}
    );
}

export default NotFound;
